import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import {
  TRANSACTION_ACTIVITY_LABELS,
  type TransactionActivityEntry,
} from '@/types/transaction-activity';
import { formatDateTime } from '@/utils/formatters';

export function TransactionActivityLog({
  entries,
  isLoading,
}: {
  entries: TransactionActivityEntry[] | undefined;
  isLoading: boolean;
}) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Activity</CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading && (
          <p className="text-sm text-muted-foreground">Loading activity…</p>
        )}
        {!isLoading && !entries?.length && (
          <p className="text-sm text-muted-foreground">No activity yet.</p>
        )}
        <ol className="space-y-3">
          {entries?.map((entry) => (
            <li key={entry.id} className="text-sm">
              <div className="flex items-baseline justify-between gap-2">
                <span>
                  <span className="font-medium text-foreground">
                    {entry.actor_name ?? 'System'}
                  </span>{' '}
                  <span className="text-muted-foreground">
                    {TRANSACTION_ACTIVITY_LABELS[entry.action].toLowerCase()}
                    {entry.fund_name && ` for ${entry.fund_name}`}
                  </span>
                </span>
                <span className="shrink-0 text-xs text-muted-foreground">
                  {formatDateTime(entry.created_at)}
                </span>
              </div>
              {entry.reason && (
                <p className="mt-1 text-muted-foreground">{entry.reason}</p>
              )}
            </li>
          ))}
        </ol>
      </CardContent>
    </Card>
  );
}
